import React, { useEffect, useRef, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { BadgeCheckIcon, XIcon } from 'lucide-react';
import { recentBuyers, purchasedPlans } from '../data/purchases';
type Purchase = {
  name: string;
  city: string;
  plan: string;
  minutesAgo: number;
};
const FIRST_DELAY_MS = 8000;
const VISIBLE_MS = 6000;
const randomBetween = (min: number, max: number) => Math.floor(Math.random() * (max - min + 1)) + min;
export function PurchasePopup() {
  const [purchase, setPurchase] = useState<Purchase | null>(null);
  const lastIndex = useRef(-1);
  useEffect(() => {
    let showTimer: number;
    let hideTimer: number;
    const show = () => {
      let idx = randomBetween(0, recentBuyers.length - 1);
      if (idx === lastIndex.current) idx = (idx + 1) % recentBuyers.length;
      lastIndex.current = idx;
      const buyer = recentBuyers[idx];
      // Premium aparece más seguido, coherente con "más elegido"
      const plan = Math.random() < 0.65 ? purchasedPlans[0] : purchasedPlans[1];
      setPurchase({
        ...buyer,
        plan,
        minutesAgo: randomBetween(1, 9)
      });
      hideTimer = window.setTimeout(() => setPurchase(null), VISIBLE_MS);
      showTimer = window.setTimeout(show, randomBetween(40, 60) * 1000);
    };
    showTimer = window.setTimeout(show, FIRST_DELAY_MS);
    return () => {
      window.clearTimeout(showTimer);
      window.clearTimeout(hideTimer);
    };
  }, []);
  return <div className="pointer-events-none fixed bottom-4 left-4 right-4 z-50 flex sm:right-auto" aria-live="polite" data-id="element-240" data-mp="n97ongw7g49u">
      <AnimatePresence data-id="element-241" data-mp="x5b1bgoonlb1">
        {purchase && <motion.div key={`${purchase.name}-${purchase.plan}-${purchase.minutesAgo}`} initial={{
        opacity: 0,
        y: 16,
        scale: 0.96
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 8,
        scale: 0.98
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} className="pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl bg-bone p-3 pr-2 text-night shadow-[0_12px_32px_rgba(0,0,0,0.45)]" role="status" data-id="element-242" data-mp="x62ivnlg3iib">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-pumpkin font-display text-base font-bold text-night" aria-hidden="true" data-id="element-243" data-mp="2fpqxcbcahzcs">
              {purchase.name.charAt(0)}
            </span>
            <div className="min-w-0 flex-1" data-id="element-244" data-mp="1rybqq6dhcvvq">
              <p className="truncate text-sm font-bold" data-id="element-245" data-mp="1rzmyeha1qns4">
                {purchase.name} <span className="font-normal text-night/70" data-id="element-246" data-mp="1wy7ymgpat7gk">de {purchase.city}</span>
              </p>
              <p className="truncate text-sm" data-id="element-247" data-mp="21v83wpebq66m">
                compró <span className="font-bold text-pumpkin-dark" data-id="element-248" data-mp="26mzlwbjez3l5">{purchase.plan}</span>
              </p>
              <p className="mt-0.5 flex items-center gap-1 text-xs text-night/60" data-id="element-249" data-mp="197lrcrn4br7m">
                <BadgeCheckIcon className="h-3.5 w-3.5 text-[#1f9d55]" aria-hidden="true" data-id="element-250" data-mp="195homd0ygy8x" />
                Compra verificada · hace {purchase.minutesAgo} min
              </p>
            </div>
            <button type="button" onClick={() => setPurchase(null)} aria-label="Cerrar notificación" className="self-start rounded-full p-1 text-night/50 transition-colors duration-150 ease-out hover:bg-night/10 hover:text-night" data-id="element-251" data-mp="3reudr804trii">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-252" data-mp="3dj9vmes89dc5" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}